<script setup lang="ts">
/**
 * Homepage teaser for /tailor-resume-to-job: what tailoring does in three
 * lines, a still of the panel, and a link to the page that explains it.
 */
const { t } = useI18n()

const points = ['match', 'rewrite', 'copy'] as const
</script>

<template>
  <section class="sofax bg-white dark:bg-gray-950">
    <div class="section-space">
      <div class="shell">
        <div class="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <div>
            <div class="eyebrow mb-5">{{ t('homepage.tailor.eyebrow') }}</div>
            <h2 class="mb-5">{{ t('homepage.tailor.title') }}</h2>
            <p class="mb-8 text-lg">{{ t('homepage.tailor.text') }}</p>
            <ul class="mb-10 flex flex-col gap-3">
              <li v-for="point in points" :key="point" class="flex items-start gap-3">
                <i class="bi bi-check-circle-fill mt-0.5 shrink-0 text-xl text-accent" />
                <span class="text-base">{{ t(`homepage.tailor.points.${point}`) }}</span>
              </li>
            </ul>
            <SofaxBtn to="/tailor-resume-to-job" :label="t('homepage.tailor.cta')" variant="dark" />
          </div>

          <div class="relative mx-auto w-full max-w-[31.25rem]">
            <MarketingTailorMockCard />
            <img
              src="/sofax/content-shape-1.svg"
              alt=""
              aria-hidden="true"
              width="125"
              height="137"
              class="pointer-events-none absolute -right-10 -top-10 -z-10 hidden xl:inline-block"
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
